import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, StaggerGroup, StaggerItem, FloatingBlob, Magnetic } from "@/components/Motion";
import { faqs } from "@/lib/data";
import SEO from "@/components/SEO";

export default function FAQ() {
  return (
    <div data-testid="faq-page" className="relative overflow-hidden">
      <SEO title="Frequently Asked Questions" description="Find answers to common questions about our obstetric and gynaecological care." />
      <FloatingBlob color="aurora-warm" size={500} top="-10%" right="-5%" delay={0} />

      <section className="py-16 lg:py-24 relative">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <Reveal>
            <div className="overline mb-4">Frequently Asked</div>
            <h1 className="font-heading text-5xl md:text-6xl text-[var(--color-text)] leading-[1.05] max-w-4xl">
              Answers to questions <em className="text-[var(--color-coral)] not-italic">most patients ask.</em>
            </h1>
          </Reveal>
        </div>
      </section>

      <section className="pb-24 relative">
        <FloatingBlob color="aurora-purple" size={400} bottom="10%" left="-10%" delay={2} />
        <div className="max-w-3xl mx-auto px-6 lg:px-8 relative z-10">
          <Reveal delay={0.2}>
            <div className="glass-card p-6 border border-[var(--color-border)]">
              <Accordion type="single" collapsible className="w-full">
                {faqs.map((f, i) => (
                  <AccordionItem
                    key={i}
                    value={`item-${i}`}
                    className="border-b border-[var(--color-border)] last:border-0"
                    data-testid={`faq-item-${i}`}
                  >
                    <AccordionTrigger className="text-left font-heading text-lg md:text-xl text-white hover:no-underline py-6 hover:text-[var(--color-coral)] transition-colors">
                      {f.q}
                    </AccordionTrigger>
                    <AccordionContent className="text-base text-white/80 leading-relaxed pb-6">
                      {f.a}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="pb-24 relative">
        <Reveal>
          <div className="max-w-5xl mx-auto px-6 lg:px-8">
            <div className="glass-card rounded-3xl p-10 lg:p-14 border border-[var(--color-coral)]/30 text-center">
              <h2 className="font-heading text-3xl md:text-4xl text-white">Still have a question?</h2>
              <p className="mt-3 text-white/80 max-w-xl mx-auto">Reach out — we&apos;ll respond personally, with care.</p>
              <div className="mt-7 flex flex-wrap justify-center gap-4">
                <Magnetic><Link to="/contact" data-testid="faq-cta-contact" className="btn-primary">Contact Us <ArrowRight className="w-4 h-4" /></Link></Magnetic>
                <Magnetic><Link to="/appointment" data-testid="faq-cta-book" className="btn-outline">Book Appointment</Link></Magnetic>
              </div>
            </div>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
